import { useTranslation } from 'react-i18next';

import { Button } from '@mui/joy';

import { type AvailableAccessKeyInstance } from '@/types/trpc/accessKeys';

import { AddIcon } from '@/shared/icons/Icons';

type Props = {
  rowData: AvailableAccessKeyInstance;
  setSelected: (accessKey: AvailableAccessKeyInstance) => void;
  selectedItems: AvailableAccessKeyInstance[];
};
const SelectAccessKeyActionsCell: React.FC<Props> = ({ rowData, setSelected, selectedItems }) => {
  const { t } = useTranslation();

  const isSelected = selectedItems.some(
    (accessKey) => accessKey.accessKeyInstanceId === rowData.accessKeyInstanceId,
  );

  return (
    <div className="flex items-center justify-center">
      <Button
        disabled={isSelected}
        onClick={() => setSelected(rowData)}
        startDecorator={<AddIcon />}
      >
        {t('select.action')}
      </Button>
    </div>
  );
};

export default SelectAccessKeyActionsCell;
